'use client';

import { useAuthStore } from '../stores/authStore';

/**
 * Single source of truth for "do we have an authed session?". With
 * cookie-only auth the cookie is httpOnly — we cannot inspect it from
 * JS — so the answer comes from the auth store, which is populated
 * from `GET /api/auth/me` on mount and from explicit login/logout
 * actions.
 */
export function useIsAuthed(): boolean {
  return useAuthStore((s) => s.isAuthenticated);
}
